import React from "react";

const WelcomeSection = () => {
  return (
    <>
      <div className="welcome-section d-none d-lg-block">
        <div className="welcome-text">
          <h1>Welcome to Your Learning Portal</h1>
          <p>
            Continue your learning journey or explore new programs to enhance
            your skills and advance your career.
          </p>
        </div>
        <img
          src="https://res.cloudinary.com/dyvxdlyrr/image/upload/v1763554520/Adobe_Express_-_file_5_hmaalc.png"
          alt="banner"
          className="banner-image"
        />
      </div>
      {/* <div className="welcome-section-sm">
        <div className="d-lg-none">
          <h1 className="text-center">IBIX Learn Hub</h1>
        </div>
      </div> */}
    </>
  );
};

export default WelcomeSection;
